export const BOT_DIFFICULTIES = ["easy", "medium", "hard", "extreme"] as const;

export type BotDifficulty = (typeof BOT_DIFFICULTIES)[number];

export type SearchBudget = Readonly<{
  maxDepth: number;
  nodeLimit: number;
  tableCapacity: number;
  candidateCount: number;
  plausibilityWindow: number;
}>;

export type DifficultyPolicy = Readonly<{
  budget: SearchBudget;
  responseCeilingMs: number;
}>;

const POLICIES: Readonly<Record<BotDifficulty, DifficultyPolicy>> = Object.freeze({
  easy: Object.freeze({
    budget: Object.freeze({
      maxDepth: 1,
      nodeLimit: 48,
      tableCapacity: 64,
      candidateCount: 3,
      plausibilityWindow: 90,
    }),
    responseCeilingMs: 250,
  }),
  medium: Object.freeze({
    budget: Object.freeze({
      maxDepth: 3,
      nodeLimit: 2_000,
      tableCapacity: 2_000,
      candidateCount: 1,
      plausibilityWindow: 0,
    }),
    responseCeilingMs: 750,
  }),
  hard: Object.freeze({
    budget: Object.freeze({
      maxDepth: 5,
      nodeLimit: 6_000,
      tableCapacity: 6_000,
      candidateCount: 1,
      plausibilityWindow: 0,
    }),
    responseCeilingMs: 2_000,
  }),
  extreme: Object.freeze({
    budget: Object.freeze({
      maxDepth: 9,
      nodeLimit: 1_000_000,
      tableCapacity: 100_000,
      candidateCount: 1,
      plausibilityWindow: 0,
    }),
    responseCeilingMs: 6_000,
  }),
});

export function isBotDifficulty(value: unknown): value is BotDifficulty {
  return value === "easy" || value === "medium" || value === "hard" || value === "extreme";
}

export function getDifficultyPolicy(difficulty: BotDifficulty): DifficultyPolicy {
  return POLICIES[difficulty];
}
